import VSignup from "../Views/VSignup";

export default class MSignup {
  private view: VSignup;

  constructor(view: VSignup) {
    this.view = view;
    this._submitEnabled = this.view.submit.hasClass("invalid");
    this.submitted = false;
  }

  private _submitted: boolean;

  public get submitted(): boolean {
    return this._submitted;
  }

  public set submitted(value: boolean) {
    this._submitted = value;
  }

  private _submitEnabled: boolean;

  public get submitEnabled(): boolean {
    return this._submitEnabled;
  }

  public set submitEnabled(value) {
    this._submitEnabled = value;
    this.view.SubmitEnabled(this._submitEnabled);
  }
}
